import React from "react";
import clsx from "clsx";

const styles = {
  primary: `
    bg-[#1E3A5F] text-[#FFC107]
    hover:bg-[#2B5388] hover:text-[#D19D00]
  `,
  secondary: `
    bg-[#F5F5F5] text-[#1E3A5F]
    hover:bg-[#DBDBDB] hover:text-[#12233A]
  `,
  tertiary: `
    bg-[#00AFA9] text-white
    hover:bg-[#00938E] hover:text-[#E0E0E0]
  `,
  danger: `
    bg-[#E74C3C] text-white
    hover:bg-[#C0392B] hover:text-[#F8F8F8]
  `,
};

export default function Button({
  variant = "primary",
  type = "button",
  icon,
  children,
  onClick,
  className = "",
  disabled = false,
}) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        // پایه: سایز موبایل (mobile-first)
        "flex items-center justify-center gap-1.5 min-h-[44px] px-3 py-2",
        "text-sm font-medium rounded-[8px]",
        // دسکتاپ (sm به بالا) همان ابعاد قبلی
        "sm:min-h-0 sm:gap-2 sm:px-4 sm:py-2 sm:text-base",
        "transition-colors duration-200",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        styles[variant],
        className
      )}
    >
      {icon && (
        <span className="w-4 h-4 sm:w-5 sm:h-5 shrink-0">{icon}</span>
      )}
      <span>{children}</span>
    </button>
  );
}
